import React, { useCallback, useEffect, useState } from 'react';
import { SalvButton, SalvDataTag, Size } from '@salvapp/ui-components';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { Card } from 'react-bootstrap';
import { ApiScreeningPersonScreeningContextConfiguration } from '../../../api';
import { personScreeningContextConfigurationApi } from '../../../apis';
import { useMe } from '../../../organisation/useMe';
import { InternalApiEntityType } from '../../../api-internal';
import ListSignificantFields from './ListSignificantFields';
import PersonSignificantUpdateIndicatorModal from './PersonSignificantUpdateIndicatorModal';
import {
  CAN_MODIFY_PERSON_SCREENING_CONTEXT_CONFIGURATION,
  CAN_READ_PERSON_SCREENING_CONTEXT_CONFIGURATION,
} from '../../../auth/permissions';
import Has from '../../../auth/Has';

const PersonSignificantUpdateIndicators = () => {
  const { currentOrganisation } = useMe();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [personSignificantFields, setPersonSignificantFields] =
    useState<ApiScreeningPersonScreeningContextConfiguration[]>();

  useEffect(() => {
    personScreeningContextConfigurationApi.findPersonScreeningContext().then((context) => {
      setPersonSignificantFields(context);
    });
  }, [currentOrganisation]);

  const updatePersonSignificantFields = useCallback(
    (significantFields: ApiScreeningPersonScreeningContextConfiguration[]) => {
      setPersonSignificantFields(significantFields);
    },
    []
  );

  return (
    <Has allPermissions={CAN_READ_PERSON_SCREENING_CONTEXT_CONFIGURATION}>
      <div className='m-t-24'>
        <div className='m-b-16' style={{ display: 'flex', gap: '12px' }}>
          <span className='title-s'>From Person data</span>
          <Has allPermissions={CAN_MODIFY_PERSON_SCREENING_CONTEXT_CONFIGURATION}>
            <SalvButton
              label='Edit'
              size={Size.EXTRA_SMALL}
              variant='muted'
              icon={faPencil}
              onClick={() => setIsModalOpen(true)}
            />
          </Has>
        </div>
        <p className='text-s'>
          We screen a Person against all applicable Lists in the first screening. Subsequently, we only re-screen them
          against new or updated List records, or when the Person’s data has been updated.
        </p>
        <p>
          Not all changes to List records or personal data may be considered significant; for instance, correcting a
          typo in a record’s source or updating a Person’s email. Below, you can choose which changes to List records
          warrant re-screening during subsequent screening events. To edit Significant Update Indicators from Person
          data, please contact Salv support.
        </p>
        <Card className='m-b-40'>
          <Card.Body>
            {personSignificantFields?.map((field) => (
              <SalvDataTag key={field.field} value={field.field} />
            ))}
          </Card.Body>
        </Card>
        <ListSignificantFields entityType={InternalApiEntityType.PERSON} />
        <PersonSignificantUpdateIndicatorModal
          fieldNames={personSignificantFields?.map((field) => field.field) ?? []}
          updatePersonSignificantFields={updatePersonSignificantFields}
          handleClose={() => setIsModalOpen(false)}
          show={isModalOpen}
        />
      </div>
    </Has>
  );
};

export default PersonSignificantUpdateIndicators;
